angular.module('subscriptionPackage', [
  'ngRoute',
  'ngResource',
  'core',
  'core.auth',
  'core.env',
  'pascalprecht.translate',
]);



// WEBPACK FOOTER //
// ./src/app/subscription-package/subscription-package.module.js